import { createSlice } from "@reduxjs/toolkit";
import { getAreas } from '../reduxApi/areaReduxApi'

const areaSlice = createSlice({
    name: 'area',
    initialState: {
        status: 'idel',
        area: [],
    },
    reducers: {
        deleteAreaAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.area.findIndex((item) => item.areas.ROWID === id);
                if (index !== -1) {
                    state.area.splice(index, 1);
                }
            });
        },
        updateAreaAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.area.findIndex((item) => item.areas.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.area.splice(index, 1, { areas: action.payload })
            }
        },
        addAreaAction: (state, action) => {
            console.log("Adding area:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.area.unshift({ areas: temp });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAreas.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getAreas.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing area Data", action.payload)
                state.area = action.payload.data.response
                    ;
            })
    }
})
export const { deleteAreaAction, updateAreaAction, addAreaAction } = areaSlice.actions
export default areaSlice.reducer